'use client';

import { FC, memo, PropsWithChildren } from 'react';

import PromotionsSlider from '../PromotionsSlider';
import RegistrationSlider from '../RegistrationSlider';
import { RegistrationSlide, Slide } from '@/api/cms';
import { ScrollTopButton } from '@/components/buttons';
import { useScrollTopBtn } from '@/hooks/scrollTopBtn';
import { FilterGames } from '@/modules/lobby/components/FilterGames';
import { useCommonStore } from '@/store';

import { ScSliderLayoutContent } from './styled';
import { ScContainer } from '@/styles/common';

interface ILayoutLobbyWithSliderProps extends PropsWithChildren {
  promoSlides: Slide[];
  regSlides: RegistrationSlide[];
  isAuthenticatedByCookie: boolean;
}

export const LayoutLobbyWithSlider: FC<ILayoutLobbyWithSliderProps> = memo(
  ({ children, promoSlides, regSlides, isAuthenticatedByCookie }) => {
    const { containerRef, gamesContainerRightOffset, isTop } =
      useScrollTopBtn();
    const isAuthenticatedClient = useCommonStore.use.isAuthenticatedByCookie();
    const isAuthenticated =
      typeof window === 'undefined'
        ? isAuthenticatedByCookie
        : isAuthenticatedClient;

    return (
      <>
        {isAuthenticated ? (
          <PromotionsSlider promoSlides={promoSlides} />
        ) : (
          <RegistrationSlider regSlides={regSlides} />
        )}
        <ScSliderLayoutContent>
          <ScrollTopButton right={gamesContainerRightOffset} isTop={isTop} />
          <FilterGames />

          {children}
        </ScSliderLayoutContent>
        <ScContainer ref={containerRef} />
      </>
    );
  }
);
